import script from "./TabUnitsDoneByLocation.vue?vue&type=script&setup=true&lang=js"
export * from "./TabUnitsDoneByLocation.vue?vue&type=script&setup=true&lang=js"

import "./TabUnitsDoneByLocation.vue?vue&type=style&index=0&id=79f3260a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79f3260a"]])

export default __exports__